import {
  CaseEvaluatorAssignment,
  EvaluationCase as BaseEvaluationCase,
} from "@/types"
import { Evaluator as GlobalEvaluator } from "@/types"

// Evaluator type
export type Evaluator = GlobalEvaluator

// EvaluationCase type (extends API type, adds UI-only fields)
export interface EvaluationCase extends BaseEvaluationCase {
  assignedEvaluators?: CaseEvaluatorAssignment[]
}

// Type for cases merged with evaluation results
export interface MergedEvaluationCase extends EvaluationCase {
  score?: number
  reason?: string
  rubric?: string
  selectedEvaluatorAssigned?: boolean
}

// Props for EvaluationCaseCard
export interface EvaluationCaseCardProps {
  caseData: EvaluationCase
  onRun: () => void
  onDelete: () => void
  onChange: (updated: Partial<EvaluationCase>) => void
}

// Storage keys for persistence
export const STORAGE_KEYS = {
  SELECTED_EVALUATOR: "evaluation-selected-evaluator",
} as const

export const ALL_EVALUATORS_STORAGE_VALUE = "__all__"
